import React from "react";

import NavbarTop from "./NavbarTop";
import Header from "./Header";
import Teams from "./Teams";
import Testimonials from "./Testimonials";
import RecentUpdates from "./RecentUpdates";
import Footer from "./Footer";
import DiseaseCards from "./DiseaseCards";

export default function Main() {
  return (
    <>
      <NavbarTop />
      <Header />
      <DiseaseCards />
      <RecentUpdates />
      {/* <Teams /> */}
      <Testimonials />
      <Footer />
    </>
  );
}
